import {
    Platform,
    Linking
} from "react-native";

export type OpenLinkConstantType = {
    href?: string;
};

export const LINK_ABSOLUTE_URL_PATTERN = /^[a-z][a-z0-9+.-]*:/i;

export const openLink = ({
    href
}: OpenLinkConstantType) => {
    if(Platform.OS === "web" || !href || !LINK_ABSOLUTE_URL_PATTERN.test(href)) {
        return;
    }

    Linking.openURL(href).catch(() => undefined);
};
